export const getTrainerResumesAPI = "/trainers-resumes";
export function openTrainerResumeAPI(id) { return "/trainers-resumes/" + id + "/open"; } 
